<template>
  <svg :width="width" :height="height" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8.58887" cy="8.58887" r="7.58887" :stroke="color" stroke-width="2" stroke-linecap="round"/>
    <path d="M21.0001 21.0001L14.7568 14.7568" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default{
  name: 'searchIcon',
  props: {
    color: {
      type: String,
      required: false,
      default: 'currentColor'
    },
    width: {
      type: [String, Number],
      default: '22'
    },
    height: {
      type: [String, Number],
      default: '22'
    }
  }
}</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/icon/SearchIcon.vue